import {
  DataWorkQuantitySheetItem,
  PutManualSimulationAllotment,
  SupplierAllocationNewItem
} from '@gateway.Simulation'

/**
 * DataWorkQuantitySheetItem [{}]
 */
const createDataWorkQuantityTypeObj = () => {
  const dataWorkQuantity = Array.from({
    length: 72
  }).map<DataWorkQuantitySheetItem>(() => {
    return { value: null, readOnly: false }
  })

  return dataWorkQuantity
}

/**
 * number[]
 */
const createDataWorkQuantityTypeNumber = () => {
  const dataWorkQuantityTypeNumber: number | null[] = []
  Array.from({
    length: 72
  }).forEach(() => {
    dataWorkQuantityTypeNumber.push(null)
  })

  return dataWorkQuantityTypeNumber
}
const _initDataWorkQuantityTypeObj = createDataWorkQuantityTypeObj()
const _initWorkQuantityTypeNumber = createDataWorkQuantityTypeNumber()

const sumBottompManualYamadumiList = [
  {
    summaryFlg: 0,
    updDtm: null,
    partKbn: null,
    partGroup: null,
    partSeq: null,
    autoAllocationFlg: null,
    displayFlg: 1,
    display: 'block',
    partNm: '全体（自動）',
    splitSupplierNumber: null,
    startYm: null,
    scheduleMonths: null,
    workQuantity: _initWorkQuantityTypeNumber
  },
  {
    summaryFlg: 0,
    updDtm: null,
    partKbn: null,
    partGroup: null,
    partSeq: null,
    autoAllocationFlg: null,
    displayFlg: 1,
    display: 'block',
    partNm: '全体（手動）',
    splitSupplierNumber: null,
    startYm: null,
    scheduleMonths: null,
    workQuantity: _initWorkQuantityTypeNumber
  }
]

/**
 * 業者配分結果取得
 * 合計行を除いてstateSupplierCalender.Length = 0の場合、空行を1行表示する
 */
const _initAllocationSupplierList = [
  {
    updDtm: null,
    /**
     * 未決フラグ
     */
    pendingFlg: null,
    /**
     * 推薦業者フラグ
     */
    recommendationSupplierFlg: null,
    /**
     * 見積物件フラグ
     */
    estimationBuildingFlg: null,
    /**
     * 業者決定物件フラグ
     */
    supplierDecisionBuildingFlg: null,
    /**
     * 表示順
     */
    displayOrder: 0,
    /**
     * 業者コード
     */
    supplierCd: null,
    /**
     * 業者名
     */
    supplierNm: null,
    /**
     * 回答依頼フラグ
     */
    replyReqFlg: null,
    delFlg: null,
    workQuantity: _initWorkQuantityTypeNumber
  }
]

/**
 * 登録・更新
 */
const putManualSimulationAllotmentData: PutManualSimulationAllotment = {
  data: {
    execInfo: {
      execKbn: ''
    },
    updCondition: {
      simulationYm: '',
      procurementNo: '',
      subNo: '',
      branchCd: '',
      expense: '',
      expenseSeq: '',
      displayStartYear: ''
    },
    expenseInfo: {
      updDtm: null,
      monthWorkday: null,
      expenseNotApplicableFlg: null,
      expenseCost: null,
      remark: null,
      structureRatioFoundation: null,
      structureRatioUnderground: null,
      structureRatioGround: null,
      constructionQuantityFoundation: null,
      constructionQuantityUnderground: null,
      constructionQuantityFloorPrecedence: null,
      constructionQuantityGround: null,
      productionRateFoundation: null,
      productionRateUnderground: null,
      productionRateFloorPrecedence: null,
      productionRateGround: null,
      scheduleFoundation: null,
      scheduleUnderground: null,
      scheduleFloorPrecedence: null,
      scheduleGround: null,
      costPerTsubo: null,
      costPerWork: null,
      workRatioPreparation: null,
      workRatioFoundationUnderground: null,
      workRatioGround: null,
      workRatioFinish: null,
      scheduleRatioPreparation: null,
      scheduleRatioFoundationUnderground: null,
      scheduleRatioGround: null,
      scheduleRatioFinish: null,
      scheduledWorkOther: null,
      scheduledWorkFinish: null,
      constant: null,
      safeRatio: null
    },
    manualYamadumiList: [],
    allocationSupplierList: []
  }
}
/**
 * 業者追加
 */
const _initM2DataSheetList: SupplierAllocationNewItem = {
  updDtm: null,
  delFlg: 0,
  pendingFlg: 0,
  unpublishedFlg: 0,
  recommendationSupplierFlg: 0,
  estimationBuildingFlg: 0,
  supplierDecisionBuildingFlg: 0,
  displayOrder: 1,
  supplierCd: '',
  supplierNm: '',
  preChangeSupplier: '',
  preChangeSupplierNm: '',
  supplierBranchCd: '',
  preChangeSupplierBranchCd: '',
  workQuantity: _initDataWorkQuantityTypeObj,
  replyReqFlg: null,
  summaryFlg: 1,
  display: 'block'
}

export {
  sumBottompManualYamadumiList,
  _initAllocationSupplierList,
  _initWorkQuantityTypeNumber,
  putManualSimulationAllotmentData,
  _initDataWorkQuantityTypeObj,
  _initM2DataSheetList
}
